const codeMngt = {
    namespaced: true,
    state : {
        code : '',
        dtlCode : '',
        codeNm : '',
        status : '',
        pageInfo : {
            page : '1',
            pageSize : '5',
            totPage : '0'
        } 
    },
    getters: {
        getCode (state) {
            return state.code
        },
        getDtlCode (state) {
            return state.dtlCode
        },
        getCodeNm (state) {
            return state.codeNm
        },
        getStatus (state) {
            return state.status
        },
        getPageInfo (state) {
            return state.pageInfo
        },
    },
    mutations: {
        setCode (state, payload) {
            state.code = payload
        },
        setDtlCode (state, payload) {
            state.dtlCode = payload
        },
        setCodeNm (state, payload) {
            state.codeNm = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },
        setPageInfo (state, payload) {
            state.pageInfo = payload
        },
    },
    actions: {
        setCode ({commit}, payload) {
            commit('setCode', payload)
        },
        setDtlCode ({commit}, payload) {
            commit('setDtlCode', payload)
        },
        setCodeNm ({commit}, payload) {
            commit('setCodeNm', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setPageInfo ({commit}, payload) {
            commit('setPageInfo', payload)
        },
        setCodeMngtInit ({commit}) {
            commit('setCode', '');
            commit('setDtlCode', '');
            commit('setCodeNm', '');
            commit('setStatus', '');
            commit('setPageInfo', {});
        },
    }
}


export default codeMngt